<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">Copyright © 2019 - {{ today | date:'y'}} <a href="https://www.oliverinformatica.com/" target="_blank"> Oliver</a> {{version}}</p>
    </div>
  </div>
</div>